import * as dayjs from 'dayjs'
import Vue from 'vue/dist/vue.common';

Vue.filter('formatDate', function (value) {
    if (!value) return ''
    value = value.toString()
    let the_date = dayjs(value);
    return the_date.format('MMMM DD, YYYY');
});
 
Vue.filter('formatTagTitle', function (value) {
    if (!value) return ''
    if (value == 'postAuthors') {
        return 'Members';
    }
    if (value == 'postCollaborators') {
        return 'Consortium';
    }
    value = value.toString()
    return value.replace("post", "");
});